// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Utilities } from '@gscope-mfe/app-bridge';

export default Utilities.createAxiosInstance();
